var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM49(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5438_45438",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5438_45438",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNElEQVRo3u1avW7CMBBmY2PmHdqhC6KA1KE8QZGaLgxdYOvC0okXgIfpkrlCsBKpkUBia9WhWTqgIpWBn+sdMiW0abAdx8RRP+mTosS+3CXn853tTOYfOwBADllG1pEtZJuxxe7Rs1ySFCYWkV2ki1zBYaxYW+pzTjKOoXgW2UCOITpIRpNk6vriFvIZ1INk3sT2R1BwHmlD/KB35FUrX0F6oA/0rooq5WvIOegHvbOmQvkFHA8LaSOY28zh+JgLuxMbsB4kBx73wGah0obkweYKsSwWR8J6uYTP1xeYPjkb0jXdUwCLZ4aVm6TWa3jvP8Lo/g4G1QL0Sid7HFwWNs+oDbWNMNllwwxoykidTcbg3F7/UvovDrHtx0Q6C2mG+b6wVM9+gP7FGbfyW1If6iuZOwUaUJRRvlc+FVb+m9hX0ohikAFdUbeR+fJBf2Im7k7dIANckQE7FPB5njEhOLDdoEpqxdubIokq5bfcRCd+rPYqO1bqcYPCoWoDSKYgyn4D6iKTVFCcj0qSKTjZ1f0GtHh70ayqWvktSbYAWn4D2ry9KDWIy4Cp64gY0E6VAca7kPGD2PgwavZEJpNKOApTCSdqKmFgMtdJZTptdkGju6ScyZeUjfiK+kFIUV/VUNQzIyxlyyqYGhC1LaukYmHL+KXFVCzu+oy4MnZ5PRUbHD/c6c3ILaZUbPJp3Ga1QMfGN+w2ukcKFNe30R1y1KADckcNinCMowYHDnuUwJTDHknAF+q7B4vmh28lAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM49);
export default __webpack_public_path__ + "static/media/m49.2d6197a63afceb0d0ea73cccb3b32c25.svg";
export { ForwardRef as ReactComponent };